import React from 'react'
import { Switch, Route, Redirect, withRouter } from 'react-router-dom'
import { withCookies, Cookies } from 'react-cookie';
import { inject, observer } from 'mobx-react';
import Layout from './components/layout/Layout'
import MarketingLayout from './components/layout/MarketingLayout'

import Home from './pages/Home';
import GolfCourseLandingPage from './pages/GolfCourseLandingPage';
import SummerSaleLandingPage from './pages/SummerSaleLandingPage';
import Information from './pages/Information';
import Playground from './pages/Playground';
import ErrorNotFound404 from './pages/ErrorNotFound404';
import Kontakt from './pages/Kontakt';
import Impressum from './pages/Impressum';
import Dataprivacy from './pages/Dataprivacy';
import Internal from './pages/Internal';
import Residence from './pages/Residence';
import Application from './pages/Application';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import GolfRules from './pages/GolfRules';
import UserStore from './stores/UserStore'

import PartnerOverview from './pages/PartnerOverview'
import Industry from './pages/Industry'
import PartnerDetail from './pages/PartnerDetail'

import { PropTypes, instanceOf } from 'prop-types';

import ReactGA from "react-ga";
import ReactPixel from 'react-facebook-pixel';

const isProd = process.env.NODE_ENV === "production"
//
// ReactGA.initialize("UA-97309398-3", { debug: !isProd, testMode: isProd });
//
// const pixel_options = {
//   debug: !isProd,
// };
//
// ReactPixel.init('172535441307405', {}, pixel_options);

const PrivateRoute = ({ render, ...rest }) => {
  return (
    <div>
      <Route {...rest} render={props => (
        UserStore.isLoggedIn ? render(props) : (
          <Redirect to={{
            pathname: '/',
            state: { from: props.location }
          }} />
        )
      )} />
    </div>
)}

const PublicRoute = ({ render, ...rest }) => {
  return (
    <div>
      <Route {...rest} render={props => (
        !UserStore.isLoggedIn ? render(props) : (
          <Redirect to={{
            pathname: '/internal',
            state: { from: props.location }
          }} />
        )
      )} />
    </div>
)}

const RedirectRoute = ({ to, ...rest }) => {
  return (
    <div>
      <Route {...rest} render={props => (
          <Redirect to={{
            pathname: to,
            state: { from: props.location }
          }} />
      )} />
    </div>
)}

const ReloadRoute = ({ ...rest }) => {
  return (
    <div>
      <Route {...rest} render={props => {
        location.reload()
        return
      }} />
    </div>
)}

class GAListener extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };

  componentDidMount() {
    this.sendPageView(this.context.router.history.location);
    this.context.router.history.listen(this.sendPageView);
  }

  sendPageView = (location) => {
    if( !(new Cookies()).get('cookies-accepted-stats') ) return

    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
  }

  render() {
    return this.props.children;
  }
}

const withBasicLayout = (Component) => {
  return (<Layout><Component /></Layout>)
}

const withMarketingLayout = (Component) => {
  return (<MarketingLayout><Component /></MarketingLayout>)
}

const withoutLayout = (Component) => {
  return (<Component />)
}

// const MainRoutes = () => ()

@inject('userStore')
@observer
class MainRoutes extends React.Component {

  async componentWillMount() {
    const sessionToken = this.props.cookies.get('parseSessionToken')
    const redirectTo = this.props.location.pathname
    //check if cookie
    if (sessionToken) {
      await this.props.userStore.loginWithToken(sessionToken).then(res => {
        this.props.history.push(redirectTo);
      }).catch(err => {
        console.error("catch", err)
      })
      this.props.history.push(this.props.location.pathname);
    }
  }

  render() {
    return (
      <main>
        { /* UserStore.isLoggedIn ? 'true' : 'false' */}
        <GAListener>
          <Switch>
            <Route exact    path='/'                          render={() => withMarketingLayout(Home)} />
            <Route exact    path='/fuer-golfclubs'            render={() => withMarketingLayout(GolfCourseLandingPage)} />
            {/* <Route exact    path='/herbst-aktion'             render={() => withMarketingLayout(SummerSaleLandingPage)} /> */}
            <RedirectRoute  path='/details-zur-plattform'     to="/" />
            <PublicRoute    path='/bewerbung'                 render={() => withoutLayout(Application)} />
            <PublicRoute    path='/login'                     render={() => withoutLayout(Login)} />
            <PublicRoute    path='/passwort-vergessen/:token' render={() => withoutLayout(ForgotPassword)} />
            <PublicRoute    path='/passwort-vergessen/'       render={() => withoutLayout(ForgotPassword)} />
            <Route          path='/kontakt'                   render={() => withBasicLayout(Kontakt)} />
            {/* <Route          path='/impressum'                 render={() => withBasicLayout(Impressum)} /> */}
            {/* <Route          path='/datenschutz'               render={() => withBasicLayout(Dataprivacy)} /> */}
            <PrivateRoute   path="/internal"                  render={() => withBasicLayout(Internal)} />
            {/* <PrivateRoute   path="/industry/:slug/q/:query"   render={() => withBasicLayout(Industry)} /> */}
            {/* <PrivateRoute   path="/industry/:slug"            render={() => withBasicLayout(Industry)} /> */}
            {/* <PrivateRoute   path="/partners/q/:query"         render={() => withBasicLayout(PartnerOverview)} /> */}
            {/* <PrivateRoute   path="/partners"                  render={() => withBasicLayout(PartnerOverview)} /> */}
            {/* <PrivateRoute   path="/residence"                 render={() => withBasicLayout(Residence)} /> */}
            {/* <PrivateRoute   path="/rules"                     render={() => withBasicLayout(GolfRules)} /> */}
            {/* <Route          path='/playground'                render={() => withBasicLayout(Playground)} /> */}
            {/* <PrivateRoute   path="/partner/:shortname"        render={() => withBasicLayout(PartnerDetail)} /> */}
            <ReloadRoute    path="*" />
          </Switch>
        </GAListener>
      </main>
    )
  }
}

MainRoutes.propTypes = {
  cookies: instanceOf(Cookies).isRequired
};

export default withRouter(withCookies(MainRoutes))



// WEBPACK FOOTER //
// /src/MainRoutes.js